import { useMutation } from "@apollo/client";
import { SAVE_POST } from "../api/save-post";
import { PostInput } from "gql/graphql";
import { usePosts } from "@/modules/feed/entities/post";
import { GET_MY_POSTS } from "@/modules/feed/widgets/my-posts/api/get-my-posts";
import { GET_POSTS_FOR_MODERATION } from "@/modules/feed/widgets/posts-moderation/api/get-posts-for-moderation";

export function useSavePost() {
  // новый пост в списках ещё не существует, а у правленого мог смениться текст,
  // по которому список фильтруется, — обновление кэша по id этого не покрывает
  const [create, { loading }] = useMutation(SAVE_POST, {
    refetchQueries: [GET_MY_POSTS, GET_POSTS_FOR_MODERATION],
    awaitRefetchQueries: true,
  });
  const { updateById } = usePosts();

  /**
   * Новый пост в ленту не поднимаем: он сохраняется черновиком и не виден никому,
   * кроме автора, — пока его не опубликует модератор.
   */
  const save = async (post: PostInput) => {
    const { data } = await create({
      variables: {
        post,
      },
    });

    if (!data?.savePost) {
      return;
    }

    if (post.id) {
      updateById(post.id, data.savePost);
    }

    return data.savePost;
  };

  return {
    save,
    loading,
  };
}
